import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from '@mui/material';
import { removeMahiTokenString } from "../state/mahiToken";
// import { useEffect } from "react";
// import { EventType } from "@azure/msal-browser";

const env = process.env.REACT_APP_ENV;
const envConfig = require(`../../config/config.${env}.json`);

/**
 * Renders a sign-out button
 */
export const SignOutButton = (props) => {
    const { instance } = useMsal();
    const buttonColor = env === 'production' ? 'primary' : 'secondary';

    // useEffect(() => {
    //     // This will be run on component mount
    //     const callbackId = instance.addEventCallback((message) => {
    //         console.log('SignOutButton event callback message', message)
    //         // This will be run every time an event is emitted after registering this callback
    //         //
    //         // Previously we checked LOGOUT_SUCCESS but this was too soon and caused fetch errors
    //         //
    //         if (message.eventType === EventType.LOGOUT_END) {
    //             // const result = message.payload;    
    //             // Do something with the result
    //             console.log('SignOutButton EventType.LOGOUT_END removing mahi token')
    //             removeMahiTokenString()
    //         }
    //     });

    //     return () => {
    //         // This will be run on component unmount
    //         console.log('SignOutButton useEffect removing callback')
    //         if (callbackId) {
    //             instance.removeEventCallback(callbackId);
    //         }
    //     }
        
    // }, [instance]);

    const handleLogout = async (logoutType) => {
        console.log('SignOutButton handleLogout removing Mahi token and logging out')
        removeMahiTokenString()
        if (logoutType === "popup") {
            await instance.logoutPopup({
                postLogoutRedirectUri: "/",
                mainWindowRedirectUri: "/"
            });
        } else if (logoutType === "redirect") {
            await instance.logoutRedirect({
                postLogoutRedirectUri: envConfig.auth.postLogoutRedirectUri,
            });
        }
    }
    return (
        <Button variant="contained" color={buttonColor} size="large" onClick={() => handleLogout("redirect")}>{props.label}</Button>
    )
}